import styled from 'styled-components';
import {
  Text, crTheme
} from '@comicrelief/component-library';

export const FormFieldsWrapper = styled.div`
  margin: 2rem 0 3rem;
  > * {
    margin-top: 0.8rem;
  }
`;

export const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 1rem;
  margin: 2rem 0 1rem;
  
  @media ${crTheme.allBreakpoints('M')} {
    padding: 0 2rem;
  }
`;

export const StyledText = styled(Text)`
  && {
    margin: 0;
  }
`;

export const AccountHolderWrapper = styled.div`
  margin-bottom: 1.5rem;
`;

export const Detail = styled.div`
  margin-bottom: 1.5rem;

  &:last-of-type {
    margin-bottom: 0.5rem;
  }

  span {
    display: block;

    // 'Detail' name:
    &:nth-child(1) {
      margin-bottom: 0.5rem;
    }
  }
`;

export const ReviewDetailsHeader = styled(Text)`
  display: block;
  margin-bottom: 1.9rem;
`;

export const EditDirectDebitDetailsWrapper = styled.div`
  margin-top: 2rem;
`;
